const Menu = [
  {
    label: 'PRS KOREA 2022',
    pathname: '/welcome',
    display: true,
    children: [
      {
        label: 'Welcome Message',
        pathname: '/welcome',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Overview',
        pathname: '/overview',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Committee',
        pathname: '/committee',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'News & Notice',
        pathname: '/bbs',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Previous Conference',
        pathname: 'https://prskorea2021.webconference.kr/',
        display: true,
        url: true,
      },
    ],
  },
  {
    label: 'Program',
    pathname: '/program/list',
    display: true,
    children: [
      {
        label: 'Program at a Glance',
        pathname: '/program/list',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Scientific Program',
        pathname: '/program/program',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Invited Speakers',
        pathname: '/program/speakers',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Social Event',
        pathname: '/program/socialevent',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Downloads',
        pathname: '/downloads',
        display: true,
        url: false,
        open: true,
      },
    ],
  },
  {
    label: 'Free Paper',
    pathname: '/paper/guide',
    display: true,
    children: [
      {
        label: 'Guidelines',
        pathname: '/paper/guide',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Online Submission',
        pathname: '/paper/submission',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Presentation Guideline',
        pathname: '/paper/presentation',
        // pathname: '/main',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Preview & Modification',
        pathname: '/paper/preview',
        display: false,
        url: false,
        open: true,
      },
    ],
  },
  {
    label: 'Registration',
    // pathname: '/registration/guide',
    pathname: '/main',
    display: true,
    children: [
      {
        label: 'Guidelines',
        // pathname: '/main',
        pathname: '/registration/guide',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Online Registration',
        // pathname: '/main',
        pathname: '/registration/submission',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Check Registration',
        pathname: '/registration/preview',
        display: false,
        url: false,
        open: false,
      },
      {
        label: 'Gala Dinner',
        pathname: '/registration/galadinner',
        display: true,
        url: false,
        open: true,
      },
    ],
  },
  {
    label: 'Speaker Abstracts',
    pathname: '/speaker/guide',
    // pathname: '/main',
    display: true,
    children: [
      {
        label: 'Guidelines',
        pathname: '/speaker/guide',
        // pathname: '/main',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Online Submission',
        pathname: '/speaker/submission',
        // pathname: '/main',
        display: true,
        url: false,
        open: true,
      },
    ],
  },
  {
    label: 'Sponsorship',
    pathname: '/sponsor/information',
    // pathname: '/main',
    display: true,
    children: [
      {
        label: 'Sponsorship & Opportunities',
        pathname: '/sponsor/information',
        // pathname: '/main',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Online Exhibition Application',
        pathname: '/sponsor/application',
        // pathname: '/main',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Sponsors',
        pathname: '/sponsor/list',
        display: true,
        url: false,
        open: true,
      },
    ],
  },
  {
    label: 'My Page',
    pathname: '/mypage',
    display: false,
    children: [
      {
        label: 'Home',
        pathname: '/mypage',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Personal Information',
        pathname: '/mypage',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'LOGIN',
        pathname: '/signin',
        display: false,
        url: false,
        open: true,
      },
      {
        label: 'Sign Up',
        pathname: '/choose',
        display: false,
        url: false,
        open: true,
      },
      {
        label: 'Free Paper Submission',
        pathname: '/mypage',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Registration',
        pathname: '/mypage',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Abstract Review',
        pathname: '/mypage',
        display: false,
        url: false,
        open: true,
      },
      // {
      //   label: 'Registration',
      //   pathname: '/mypage',
      //   display: true,
      // },

      {
        label: 'Speaker Abstracts Submission',
        pathname: '/mypage',
        display: true,
        url: false,
        open: true,
      },

      {
        label: 'Downloads',
        pathname: '/downloads',
        display: false,
        url: false,
        open: false,
      },
      // {
      //   label: 'LOGIN',
      //   pathname: '/signin',
      //   display: false,
      // },
      // {
      //   label: 'Sign Up',
      //   pathname: '/choose',
      //   display: false,
      // },
    ],
  },

  {
    label: 'General Information',
    pathname: '/',
    display: true,
    children: [
      {
        label: 'Venue',
        pathname: '/info/venue',
        display: true,
        url: false,
        open: true,
      },
      {
        label: 'Floor Plan',
        pathname: '/main',
        display: true,
        url: false,
        open: false,
      },
      {
        label: 'About Korea',
        pathname: '/info/korea',
        display: true,
        url: false,
        open: true,
      },
      {
        label: ' Getting to the Venue',
        pathname: '/info/gettingvenue',
        display: true,
        url: false,
        open: true,
      },

      {
        label: 'Accommodation',
        pathname: '/info/accommodation',
        display: true,
        url: false,
        open: true,
      },

      {
        label: 'COVID-19 Notice',
        pathname: '/info/covid',
        display: true,
        url: false,
        open: true,
      },
      // {
      //   label: 'Floor Plan',
      //   pathname: '/info/visa',
      //   display: true,
      //   url: false,
      //   open: false,
      // },
    ],
  },
];

export default Menu;
